import React, { useState } from 'react';
import {useHistory} from 'react-router-dom';
import { connect } from 'react-redux';
import { postExpress } from '../../../service/api';
import NoticeCreateMain from '../../presentation/section/notice-create-page/NoticeCreateMain';
import * as path from '../../../route/PathConfig';

const NoticeCreate = (props) => {
  const [noticeContent, setNoticeContent] = useState('');
  const [noticeTitle, setNoticeTitle] = useState('');
  const [noticeVisible, setNoticeVisible] = useState(1);

  let history = useHistory();

  const handleTitleInput = (event) => {
    setNoticeTitle(event.target.value);
  }

  const handleNoticeContent = (content) => {
    setNoticeContent(content);
  }

  const handleSaveBtn = () => {
    postExpress('/notice/notice-content', {
      email: props.currentUser,
      content: noticeContent,
      title: noticeTitle,
      visible: noticeVisible,
      onTop: 0,
      isInsight: 0
    },(response) => {
      history.push(`${path.NOTICE}`);
    })
  }


  return (
    <NoticeCreateMain handleSaveBtn={handleSaveBtn} noticeTitle={noticeTitle} handleTitleInput={handleTitleInput} handleNoticeContent={handleNoticeContent}/>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});

export default connect(mapStateToProps) (NoticeCreate);